import { render, staticRenderFns } from "./RobotArea.vue?vue&type=template&id=73145fa4&scoped=true&"
import script from "./RobotArea.vue?vue&type=script&lang=js&"
export * from "./RobotArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73145fa4",
  null
  
)

export default component.exports